import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateCompanyRequestBody = ApiRequestBody<
  typeof endpoints.companies,
  'post'
>;

export const useCreateCompanyMutation = () => {
  return useMutation({
    mutationFn: async (body: CreateCompanyRequestBody) => {
      const { data } = await fetchClient.POST(endpoints.companies, { body });
      return data;
    },
    onSettled: () => {
      invalidateQuery(companiesQueryKeys.list())();
    },
  });
};
